import { Flex } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";

import { ReactComponent as EditIcon } from "images/editIcon.svg";
import { ContractEditAddressModal } from "./ContractEditAddressModal";
import { CONTRACT_ADDRESS_TYPE, USER_SCOPE_ENUM } from "interfaces";

interface IProps {
  text?: string;

  type: CONTRACT_ADDRESS_TYPE;
}

export const ContractEditAddressBtn = observer((props: IProps) => {
  const { actionModals, user } = useStores();
  const { text, type } = props;
  const { isCustomer, isSeniorOperator } = user.roles;

  const showEditAddressBtn = isCustomer || isSeniorOperator;

  const editFeeHandler = () => {
    actionModals.open(() => <ContractEditAddressModal type={type} />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Редактирование адреса",
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
    <Flex gap="small" align="center">
      {text}
      {showEditAddressBtn && <EditIcon className="cursor-pointer" onClick={editFeeHandler} style={{ flexShrink: 0 }} />}
    </Flex>
  );
});
